const question7 = {
    'question': 'Jak przygotować się do pierwszej wizyty?',
    'answer': 'Pierwsze spotkanie nie wymaga szczególnego przygotowania ze strony pacjenta. Jest ono okazją aby specjalista poznał pacjenta oraz problemy z którymi się zmaga. Warto aby osoba która podjęła pierwsze kroki nie krępowała się i mówiła otwarcie o trudnościach z którymi chce się zmierzyć. Dzięki temu terapeuta może obrać odpowiedni kierunek pracy z pacjentem.'
}

export default question7;